var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: {
        "on-visible-change": "modelchange",
        closable: _vm.clos,
        "mask-closable": false,
        width: "600",
      },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "p",
        { staticClass: "modalHead", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v(_vm._s(_vm.modalheader))])]
      ),
      _vm.isKbankAlternativeRefund
        ? _c(
            "div",
            { staticClass: "modalContent" },
            [
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-bottom": "20px",
                    "font-weight": "500",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("webList.webDetail.tips")) + " ")]
              ),
              _c(
                "el-form",
                {
                  ref: "notOriginalForm",
                  staticClass: "formstyle",
                  attrs: {
                    inline: true,
                    "label-position": "left",
                    "label-width": "155px",
                    model: _vm.notOriginalForm,
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "bankCode",
                        label: _vm.$t("webList.webDetail.bankName"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputstyle",
                          attrs: { filterable: "" },
                          model: {
                            value: _vm.notOriginalForm.bankCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.notOriginalForm, "bankCode", $$v)
                            },
                            expression: "notOriginalForm.bankCode",
                          },
                        },
                        _vm._l(_vm.bankList, function (bank, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: bank.label, value: bank.value },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("webList.webDetail.tips2"),
                            placement: "bottom",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-info",
                            staticStyle: {
                              color: "#999",
                              "margin-left": "5px",
                              cursor: "pointer",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "accountName",
                        label: _vm.$t("webList.webDetail.accountName"),
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "inputstyle",
                        attrs: { type: "text" },
                        model: {
                          value: _vm.notOriginalForm.accountName,
                          callback: function ($$v) {
                            _vm.$set(_vm.notOriginalForm, "accountName", $$v)
                          },
                          expression: " notOriginalForm.accountName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "accountNumber",
                        label: _vm.$t("webList.webDetail.accountNumber"),
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "inputstyle",
                        attrs: { type: "text" },
                        model: {
                          value: _vm.notOriginalForm.accountNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.notOriginalForm, "accountNumber", $$v)
                          },
                          expression: "notOriginalForm.accountNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.cardType === "SCB" || _vm.cardType === "KMA"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "tradeVoucherId",
                            label: _vm.$t("webList.webDetail.tradeVoucherId"),
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "inputstyle",
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.notOriginalForm.tradeVoucherId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.notOriginalForm,
                                      "tradeVoucherId",
                                      $$v
                                    )
                                  },
                                  expression: "notOriginalForm.tradeVoucherId",
                                },
                              }),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t(
                                      "webList.webDetail.tradeVoucherIdSample"
                                    ),
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-info",
                                    staticStyle: {
                                      color: "#999",
                                      "margin-left": "5px",
                                      cursor: "pointer",
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "fileList",
                        label: _vm.$t("webList.webDetail.paymentSlip"),
                      },
                    },
                    [
                      _c("images-upload", {
                        attrs: {
                          "pay-request-id": _vm.transactionId,
                          limit: 3,
                          "max-size": 3,
                        },
                        model: {
                          value: _vm.notOriginalForm.fileList,
                          callback: function ($$v) {
                            _vm.$set(_vm.notOriginalForm, "fileList", $$v)
                          },
                          expression: "notOriginalForm.fileList",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "12px",
                    color: "#999",
                    "margin-left": "5px",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("webList.webDetail.paymentSlipSample")) +
                      " "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#40ADFF", cursor: "pointer" },
                      on: { click: _vm.downloadImages },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("webList.webDetail.downloadPaymentSlip"))
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        : _c("div", { staticClass: "modalContent" }, [
            _c("p", [
              _vm._v(
                _vm._s(_vm.modalcontent) +
                  " " +
                  _vm._s(_vm.currency) +
                  " " +
                  _vm._s(_vm.$filters.money(_vm.amount))
              ),
            ]),
            _c(
              "div",
              [
                _c(
                  "pp-row",
                  [
                    _c(
                      "pp-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "pp-form",
                          {
                            ref: "formCustom",
                            staticClass: "formstyle",
                            attrs: { model: _vm.formCustom, rules: _vm.rules },
                          },
                          [
                            _c(
                              "pp-form-item",
                              {
                                staticClass: "control-input",
                                attrs: { prop: "confirmAmount" },
                              },
                              [
                                _c("pp-input", {
                                  staticClass: "inputstyle",
                                  attrs: {
                                    value: _vm.formCustom.confirmAmount,
                                    type: "text",
                                    placeholder: _vm.currency,
                                  },
                                  model: {
                                    value: _vm.formCustom.confirmAmount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formCustom,
                                        "confirmAmount",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formCustom.confirmAmount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("pp-col", { attrs: { span: 12 } }, [
                      _c(
                        "div",
                        { staticClass: "all", on: { click: _vm.getAllAmount } },
                        [_vm._v(_vm._s(_vm.$t("webList.webDetail.allFunds")))]
                      ),
                    ]),
                  ],
                  1
                ),
                _c("p", { staticStyle: { color: "#999" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("webList.tradeDetail.refundTips1st")) +
                      " "
                  ),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("webList.tradeDetail.refundTips2nd")) +
                      " "
                  ),
                ]),
                _vm.refundType === "NONE"
                  ? _c(
                      "div",
                      { staticClass: "not-original-refund" },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              color: "#999",
                              "margin-bottom": "16px",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("webList.tradeDetail.refundTips3nd")
                              )
                            ),
                          ]
                        ),
                        _c(
                          "el-form",
                          {
                            ref: "notOriginalForm",
                            staticClass: "formstyle",
                            attrs: {
                              inline: true,
                              "label-position": "left",
                              "label-width": "150px",
                              model: _vm.notOriginalForm,
                              rules: _vm.rules,
                            },
                          },
                          [
                            _vm._l(
                              _vm.notOriginalConfig,
                              function (item, index) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      key: index,
                                      attrs: {
                                        prop: item.prop,
                                        label: item.label,
                                      },
                                    },
                                    [
                                      item.type === "text"
                                        ? _c("el-input", {
                                            staticClass: "inputstyle",
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.notOriginalForm[item.prop],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.notOriginalForm,
                                                  item.prop,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "notOriginalForm[item.prop]",
                                            },
                                          })
                                        : item.type === "select"
                                        ? _c(
                                            "el-select",
                                            {
                                              staticClass: "inputstyle",
                                              attrs: { filterable: "" },
                                              model: {
                                                value:
                                                  _vm.notOriginalForm[
                                                    item.prop
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.notOriginalForm,
                                                    item.prop,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "notOriginalForm[item.prop]",
                                              },
                                            },
                                            _vm._l(
                                              item.options,
                                              function (list, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: list,
                                                    value: list,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "pp-button",
            {
              attrs: { type: "primary", size: "spec", loading: _vm.loading2 },
              on: {
                click: function ($event) {
                  return _vm.commit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("webList.webDetail.confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }